import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { toast } from "sonner";

const LS_KEY = "sf_wishlist";
const WishlistContext = createContext(null);

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try { setItems(JSON.parse(localStorage.getItem(LS_KEY) || "[]")); } catch { setItems([]); }
  }, []);

  const persist = (next) => {
    setItems(next);
    localStorage.setItem(LS_KEY, JSON.stringify(next));
  };

  const has = (product_id) => items.some((p) => p.product_id === product_id);

  const toggle = (product) => {
    if (has(product.product_id)) {
      persist(items.filter((p) => p.product_id !== product.product_id));
      toast.info(`Removed ${product.name} from wishlist`);
    } else {
      persist([...items, {
        product_id: product.product_id,
        name: product.name,
        price: product.price,
        mrp: product.mrp,
        category: product.category,
        images: product.images,
      }]);
      toast.success(`Added ${product.name} to wishlist`);
    }
  };

  const remove = (product_id) => persist(items.filter((p) => p.product_id !== product_id));
  const clear = () => persist([]);

  const value = useMemo(
    () => ({ items, count: items.length, has, toggle, remove, clear }),
    [items] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <WishlistContext.Provider value={value}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => useContext(WishlistContext);
